// import { useAuth } from "./app/useAuth";
import { useNavigate } from "react-router-dom";
import React, { useEffect, useState, useCallback } from "react";
import MainLayout from "../../components/layouts/main";

export default function Search() {
    // const auth = useAuth();
    const navigate = useNavigate();
    const [textSearch, setTextSearch] = useState("");
    const [submitSearch, setSubmitSearch] = useState(false);
    const [advancedSearchText, setAdvancedSearchText] = useState("");

    const handleSubmitSearch = useCallback(() => {
        navigate(`/search/igv/${textSearch}`);
        setSubmitSearch(false);
    }, [textSearch, navigate]);

    useEffect(() => {
        if (submitSearch) {
            handleSubmitSearch();
        }
    }, [submitSearch, handleSubmitSearch]);

    return (
        <MainLayout
            pathname="/"
            header="Search"
            exampleText={
                <div>
                    Examples <br/> Gene: <span className="text-primary">Os01g0109700</span>{" "}
                    Position : <span className="text-primary">1-25883</span>{" "}
                    Marker ID: <span className="text-primary">RM462</span>, <span className="text-primary">S1442</span>{" "}
                    SNV ID: <span className="text-primary">vcZ240GYV</span>, <span className="text-primary">vcZ240GZ0</span>{" "}
                </div>
            }
            textSearch={textSearch}
            setTextSearch={setTextSearch}
            setSubmitSearch={setSubmitSearch}
            setAdvancedSearchText={setAdvancedSearchText}
        />
    );
}
